import { Component } from '@angular/core';

@Component({
  selector: 'zodi-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {}
